module.exports = __webpack_public_path__ + "img/ico-caret-right-blue.b5db78e2.svg";